import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
 
const faqs = [
  {
    q: "既存のSharePoint環境を壊さずに導入できますか",
    a: "はい。SPFxはSharePointの標準機能に手を加えずに動く仕組みです。いまのサイト構成やデータはそのままに、必要な機能だけを後から追加できます。",
  },
  {
    q: "Copilotやteamsアプリとの連携はできますか？",
    a: "はい。Copilotからの情報参照や、Teamsタブへの表示にも対応可能です。",
  },
  {
    q: "デザインはどこまでカスタマイズできますか？",
    a: "React／TypeScriptで作り込むため、業務フローに合わせた自由なデザインが可能です。",
  },
];
 
const Faq = () => {
  const [expanded, setExpanded] = useState(0);
 
  const handleChange = (index) => (event, isExpanded) => {
    setExpanded(isExpanded ? index : false);
  };
 
  return (
    <Box sx={{ backgroundColor: "#fff", py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          sx={{
            color: "#FF6000",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          FAQ
        </Typography>
 
        <Typography
          sx={{ fontWeight: 700, fontSize: { xs: "26px", md: "50px" }, mb: { xs: 4, md: 5 } }}
        >
          よくあるご質問
        </Typography>
 
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, maxWidth: '85%'}}>
          {faqs.map((item, index) => {
            const isExpanded = expanded === index;
            return (
              <Accordion
                key={item.q}
                expanded={isExpanded}
                onChange={handleChange(index)}
                elevation={0}
                disableGutters
                square
                sx={{
                  borderRadius: "6px !important",
                  border: "1px solid rgba(0,0,0,0.12)",
                  backgroundColor: "#fff",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  sx={{
                    minHeight: "auto",
                    px: 2.5,
                    py: 1.5,
                    "& .MuiAccordionSummary-content": {
                      margin: 0,
                      alignItems: "center",
                    },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "15px",
                        color: isExpanded ? "#FF6000" : "rgba(0,0,0,0.6)",
                        lineHeight: 1,
                        width: "14px",
                        flexShrink: 0,
                      }}
                    >
                      {isExpanded ? "−" : "+"}
                    </Typography>
                    <Typography sx={{ fontWeight: 700, fontSize: "14px" }}>
                      Q.{item.q}
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ pt: 0, pb: 2, px: 2.5, pl: "52px" }}
                >
                  <Typography
                    sx={{ fontSize: "13px", color: "rgba(0,0,0,0.6)", lineHeight: 1.7 }}
                  >
                    A. {item.a}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};
 
export default Faq;